<template>
  <v-row align="start" justify="center">
    <v-col v-for="broker in brokers" :key="broker.name" cols="12" sm="12" md="4" lg="3" xl="2">
      <v-card>
        <v-img :src="broker.logo"></v-img>
        <v-card-actions>
          <v-btn text color="primary">
            <v-icon class="mr-3">mdi-account-plus</v-icon>Register
          </v-btn>
          <v-spacer />
          <v-btn text color="primary" @click="onSelect(broker)">
            <v-icon class="mr-3">fingerprint</v-icon>Authorize
          </v-btn>
          <v-spacer />
          <v-btn icon @click="onMore(broker.name)">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text v-if="more == broker.name">{{broker.description}}</v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
//  'https://connect.spotware.com/apps/token?grant_type=authorization_code&code=9aff1f977c6edf1765569b10900faab82a98ade3305b4acb019ab02a3d3598fa5d0c6bc64a6e6baf1b7313&redirect_uri=http://localhost:8080/accounts&client_id=1289_NxRx9RZGpWXHGKVIchQDdl2tczIojPC1ecYinucQr6JHMUm2wR&client_secret=oAFGKldB8yAPGFaQhnIDvnxuByYzz7abSmfwxOGIpmAS9vcwS6'
export default {
  name: "BrokerCard",
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      more: null,
      brokers: [
        {
          name: "OANDA",
          type: "oanda",
          logo: require("@/assets/brokers/oanda.png"),
          description:
            "OANDA is well known to experienced traders in the forex market. While its standard trading platforms and below-average trading costs are attractive, the company tries to differentiate itself with superior execution quality and transparency."
        },
        {
          name: "FXCM",
          type: "fxcm",
          logo: require("@/assets/brokers/fxcm.png"),
          description:
            "FXCM is a market-making broker with a long history in the market, having been founded in 1999 in New York. The venerable broker now has headquarters in London, UK and is regulated by the country’s Financial Conduct Authority (FCA), as well as many other strict regulatory authorities around the world including in Australia (ASIC), South Africa, and several EU countries."
        },
        {
          name: "FxPro",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/fxpro.png"),
          description:
            "With over 15 years of excellence and over 60 International awards, FxPro has successfully expanded to serve retail and institutional clients in over 170 countries. Authorized by numerous financial regulators, including the FCA, CySec, FSCA, DFSA and SCB, it secured a solid trust record and a loyal customer base, thanks to the transparency of its operations and a real customer-centric approach."
        },
        {
          name: "IcMarkets",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/icmarkets.png"),
          description:
            "IC Markets is an Australia-based, ASIC regulated, ECN forex broker, bridging the gap between retail and institutional traders. With a combination of a cutting-edge trading platform, low latency, and superior liquidity, as well as a strong base in the values of trust, integrity and innovation － IC Markets remains a rightful choice of thousands of traders worldwide, be it active day traders, professional scalpers, or new market entrants."
        },
        {
          name: "Pepperstone",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/pepperstone.png"),
          description:
            "Pepperstone is an online Forex and CFD Broker, providing traders across the globe with cutting-edge technology to trade the world’s markets. Striving to offer the best platforms with low-cost pricing access, reliable trading infrastructure, fast execution, and exceptional client support － they combine years of market intelligence and experience, in order to deliver an utmost valuable trader experience."
        },
        {
          name: "Axiory Global",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/axiory.png"),
          description:
            "Axiory Global, fully regulated by the IFSC and ISRS 4400 by PWC, provides truly unique and innovative brokerage services. Visionaries and pioneers, they understand how quickly the world evolves, and how much expectations of brokers are rising from day to day. That’s why they prefer to avoid playing catch-up, and always stay a step ahead of the game, be it by means of fast execution, competitive spreads, solid fund security reputation, or an appealing liquidity level."
        },
        {
          name: "Fondex",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/fondex.png"),
          description:
            "Fondex was born in determination to offer clients high-end trading services, while adhering to the values of integrity and trustworthiness. Currently boasting a solid base of loyal traders, they consider themselves the broker of choice for those in search of a well-diversified portfolio, as their offering goes over 1,000 instruments across a whole of 6 asset classes."
        },
        {
          name: "OctaFX",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/octafx.png"),
          description:
            "OctaFX uses the most up-to-date technology and knowledge to make your forex trading experience incredibly convenient. OctaFX is CySEC regulated broker, using up-to-date technology and providing reliable platforms for a complete and convenient trader experience. Adhering to strict security standards and equipped with segregated accounts and negative balance protection, this broker always places clients’ fund security in the forefront, establishing a reliable, fair and transparent entity in the ever-changing forex environment."
        },
        {
          name: "RoboForex",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/roboforex.png"),
          description:
            "RoboForex is an IFSC regulated broker, providing customers and partners with quality brokerage services, using a combination of extended market experience, as well as innovative tools and technologies. With an offering of 8 asset types, and more than 9,400 trading instruments － it’s a winner of over 10 awards, including “Best Investment Products 2017” of the London Forex Show, “The Best ECN Broker 2016” of the IAFT Awards and “Best Crypto Broker 2018” of the Manchester Investor Show."
        },
        {
          name: "Scandinavian Capital Markets",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/ScandinavianCapitalMarkets.jpg"),
          description:
            "Known for building long-lasting client relationships based on trust and transparency, Scandinavian Capital Markets is a globally recognized, Swedish Financial Supervisory Authority regulated ECN/STP broker. Offering the ultimate package of prime brokerage account features, including competitive spreads, low commissions and a deep liquidity pool, backed by Top Tier 1 institutions, it is a secure and trusted choice for hundreds of traders worldwide."
        },
        {
          name: "Skilling",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/skilling.png"),
          description:
            "With a goal to make trading simple and accessible to everyone in a transparent and secure environment, Skilling is a trusted, CySEC regulated broker, boasting an offering of 800+ Forex and CFD instruments for traders to choose from. With competitively low spreads, micro lot trading availability and high leverage options for professional clients, it caters for every experience level and trading style. "
        },
        {
          name: "OMF",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/OMF.png"),
          description:
            "OMF is an NZX regulated brokerage with a strong and established reputation in the financial markets. Advising and facilitating the trading of a full range of products available in the FX, carbon, energy, dairy, options, equities, CFDs and futures markets － it’s a broker of choice for numerous successful traders out there."
        },
        {
          name: "Conotoxia",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/conotoxia.png"),
          description:
            "Conotoxia prides itself in being one of the largest financial service providers in Poland. Its competitive, transparent and trader-oriented services have won it an array of awards over the years, including Bloomberg’s October 2018th “2nd place currency forecasts for Asia and Latin America”, as well April 2019th “1st place currency forecast for EMEA”. With accessibility, convenience, and security as key – they are the broker of choice for many successful traders out there."
        },
        {
          name: "TradeView Markets",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/tradeview.png"),
          description:
            "From low spreads to flexible leverage and commission payouts, Tradeview goes a long way to support its customers in every market situation. CIMA regulation, complete protection of client funds with segregated accounts at Tier 1 banks, as well as streamlined administrative procedures and high-end technologies, ensure trader funds are safe, and needs are met with supreme speed and accuracy."
        },
        {
          name: "Trader’s Way",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/tradersway.png"),
          description:
            "Trader’s Way was established by a group of financial market professionals with a mission to provide traders the widest opportunities available in the financial markets. With a symbiosis of the best products, technologies, and services, Trader’s Way aims to satisfy the needs of every trader, ensuring they are able to trade freely, without extensive boundaries and limitations."
        },
        {
          name: "Purple Trading",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/purpletrading.png"),
          description:
            "Using their expertise within financial markets and forex trading, Purple Markets was designed to provide investors a unique trading experience, backed by top ECN/STP execution practices, advanced tools, and a safe, regulated, professional environment. Ensuring fair trading conditions, no trade-offs, and lightning-quick processing."
        },
        {
          name: "Kimura Trading",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/kimuratrading.png"),
          description:
            "Kimura Trading is an EU-regulated, multi-asset trading provider, boasting a selection of currency pairs, indices and commodity CFDs. Its Market Execution model allows increased room for such trader flexibilities, as the ability to have positions partially closed, or to conduct hedging."
        },
        {
          name: "ICM",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/icm.png"),
          description:
            "ICM is a multi-regulated Forex and CFD trading firm, offering 24-hour access to a diverse range of trading products, including foreign exchange, commodities, futures and indices. Following the ECN model, they provide traders access to comparatively high liquidity, tight spreads, and a safe, secure trading environment."
        },
        {
          name: "FXPIG",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/fxpig.png"),
          description:
            "FXPIG stands out in a market full of competitors due to its unconventional approach to business. The brokerage that speaks the truth to traders, they live by the motto – no pain, no gain. They are well aware that the trading game can get tough at times, and believe that the honesty of your broker is key to becoming the better trader of tomorrow. This philosophy, as well as a set of unique offers and conditions, is what secured FXPIG a place in the Forex sun."
        },
        {
          name: "FIBO Group",
          type: "ctrader",
          logo: require("@/assets/brokers/ctrader/fibo_group.png"),
          description:
            "One of the oldest players in marginal internet trading – FIBO Group, always had its prime focus on transparency, compliance and trader interests’ protection. Meeting the highest international standards and adhering to national regulator control, they are a broker with a solid trust record, with which you can rest assured that you and your funds are safe."
        }
      ]
    };
  },
  methods: {
    onMore(name) {
      if (this.more == name) {
        this.more = null;
      } else {
        this.more = name;
      }
    },
    onSelect(broker) {
      this.$emit("selected-broker", broker);
    },
    onAuth(broker) {
      if (broker.type == "ctrader") {
        const host = window.location.host;
        const redirect_uri = "".concat("http://", host, "/accounts");
        const open_url = "".concat(
          "https://connect.spotware.com/apps/auth?client_id=",
          process.env.VUE_APP_CTRADER_CLIENT_ID,
          "&redirect_uri=",
          redirect_uri,
          "&scope=trading"
        );
        window.open(open_url);
      }
    }
  }
};
</script>

<style>
</style>